import { Colors, Router, Storage } from '@lightningjs/sdk';
import lng from '@lightningjs/core';
import { swtichProfile } from '../../../api/profiles';
import { store } from '../../../utils/globalData';

export default class ProfileAvatar extends lng.Component {
  static _template() {
    return {
      Item: {
        Image: { collision: true },
        Name: {
          w: 254,
          y: 280,
          text: {
            fontFace: 'OpenSans-SemiBold',
            text: '',
            textAlign: 'center',
            textOverflow: 'ellipsis',
            fontSize: 36,
            wordWrapWidth: this.w,
            maxLines: 2,
            wordWrap: false,
          },
        },
      },
      FocusRing: {},
    };
  }

  _construct() {
    super._construct();
    this.spacing = 0;
  }

  set src(val) {
    this._src = val;
  }

  set subscription(val) {
    this._subscription = val;
  }

  get src() {
    return this._src;
  }

  set data({ id, language, autoplay, native_language }) {
    this._data = { id, language, autoplay, native_language };
  }

  get data() {
    return this._data;
  }

  get _Image() {
    return this.tag('Item.Image');
  }

  get _Name() {
    return this.tag('Item.Name');
  }

  get _FocusRing() {
    return this.tag('FocusRing');
  }
  set index(val) {
    this._index = val;
  }

  _focus() {
    this._FocusRing.smooth = { color: Colors('#02AC25').get() };
    //this._Name.smooth = { color: Colors('#02AC25').get() };
  }

  _unfocus() {
    this._FocusRing.smooth = { color: Colors('#d6d6d7').get() };
    //this._Name.smooth = { color: Colors('#d6d6d7').get() };
  }

  _handleHover() {
    this.fireAncestors('$setIndex', this._index);
    this.fireAncestors('$setState', 'Profiles');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._captureEnter();
  }

  _captureEnter() {
    store.clearData();
    localStorage.removeItem('subscriptionConfirmed');
    localStorage.setItem('subscription', this._subscription);
    let fp = this.application.focusPath;
    let activeTile = fp[fp.length - 1].data || {};
    if (activeTile.id !== 0) {
      swtichProfile(activeTile.id).then(({ data }) => {
        localStorage.setItem('userToken', data.token);
        Router.navigate(`browse`);
        Storage.set('profileId', this.data.id);
        Storage.set(`audiosubtitles-${this.data.id}`, {
          audio: this._data.native_language,
          subtitle: 'none',
        });
        Storage.set('profileInfo', {
          image: this._src,
          name: this.title,
          autoplay: this._data.autoplay,
          native_language: this._data.native_language,
        });
      });
    } else {
    }
  }

  _enable() {
    setTimeout(() => {
      Router.setHistory([]);
    }, 100);
    this._FocusRing.patch({
      w: this.w + this.spacing,
      h: this.h + this.spacing,
      mount: 0.5,
      x: this.w / 2,
      y: this.h / 2,
      zIndex: 2,

      texture: lng.Tools.getRoundRect(
        this.w + this.spacing,
        this.h + this.spacing,
        this.w / 2,
        5,
        Colors('#d6d6d7').get(),
        false
      ),
    });

    this._Image.patch({
      rtt: true,
      zIndex: 2,
      w: this.w,
      h: this.h,
      texture: {
        type: lng.textures.ImageTexture,
        src: this._src,
        resizeMode: { type: 'cover', w: this.w, h: this.h },
      },
      shader: {
        type: lng.shaders.RoundedRectangle,
        radius: this.w / 2,
      },
    });
    this._Name.patch({
      text: { text: this.title },
    });
  }
}
